import { combineReducers } from 'redux';

// reducer import
import loadingReducer from './loadingReducer';


const reducer = (routerReducer :any) => combineReducers({
    loading: loadingReducer,
    router: routerReducer,
    
});

export default reducer;
